import axios from 'axios';
import { getAuthToken } from '../../../utils/authHeaders';

const API_BASE_URL = '/api/manufacturer';

class InventoryService {
  private getAuthHeaders() {
    const token = getAuthToken();
    return {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    };
  }

  async getProducts(): Promise<any> {
    try {
      const response = await axios.get(`${API_BASE_URL}/products`, {
        headers: this.getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching products:', error);
      throw error;
    }
  }

  async getAnalytics(): Promise<any> {
    try {
      const response = await axios.get(`${API_BASE_URL}/analytics`, {
        headers: this.getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching analytics:', error);
      throw error;
    }
  }

  // Placeholder for future methods
  async addProduct(productData: any): Promise<any> {
    try {
      const response = await axios.post(`${API_BASE_URL}/products`, productData, {
        headers: this.getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error('Error adding product:', error);
      throw error;
    }
  }

  async updateProduct(productId: string, productData: any): Promise<any> {
    try {
      const response = await axios.put(`${API_BASE_URL}/products/${productId}`, productData, {
        headers: this.getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error('Error updating product:', error);
      throw error;
    }
  }

  async deleteProduct(productId: string): Promise<any> {
    try {
      const response = await axios.delete(`${API_BASE_URL}/products/${productId}`, {
        headers: this.getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error('Error deleting product:', error);
      throw error;
    }
  }

  // Inventory stock management methods
  async getInventoryStock(practiceId: string, productId: string): Promise<any> {
    try {
      const response = await axios.get(`/api/inventory/practice/${practiceId}/product/${productId}`, {
        headers: this.getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching inventory stock:', error);
      throw error;
    }
  }

  async updateInventoryStock(practiceId: string, productId: string, stockData: any): Promise<any> {
    try {
      const response = await axios.put(`/api/inventory/practice/${practiceId}/product/${productId}`, stockData, {
        headers: this.getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error('Error updating inventory stock:', error);
      throw error;
    }
  }

  // Simplified product stock update (uses the new endpoint)
  async updateProductStock(productId: string, stockData: any): Promise<any> {
    try {
      const response = await axios.put(`/api/products/${productId}/stock`, stockData, {
        headers: this.getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error('Error updating product stock:', error);
      throw error;
    }
  }

  async getPracticeInventory(practiceId: string): Promise<any> {
    try {
      const response = await axios.get(`/api/inventory/practice/${practiceId}`, {
        headers: this.getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching practice inventory:', error);
      throw error;
    }
  }

  async createSampleInventory(practiceId: string): Promise<any> {
    try {
      const response = await axios.post(`/api/inventory/practice/${practiceId}/sample`, {}, {
        headers: this.getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error('Error creating sample inventory:', error);
      throw error;
    }
  }

  async updateProductVariant(productId: string, variantData: any): Promise<any> {
    try {
      const response = await axios.put(`/api/products/${productId}/variants`, variantData, {
        headers: this.getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error('Error updating product variant:', error);
      throw error;
    }
  }

  async updateBaseProductStock(productId: string, stockData: any): Promise<any> {
    try {
      const response = await axios.put(`/api/products/${productId}/base-stock`, stockData, {
        headers: this.getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error('Error updating base product stock:', error);
      throw error;
    }
  }
}

export default new InventoryService();
